import { fetchApi, getUserId } from 'shared/functions';

export const postOrder = async ({ id, type, frequency, productCategory, purchaseType }) => {
  const userId = getUserId();

  const resourceUrl = `/storefront/users/${userId}/orders`;

  const params = {
    method: 'POST',
    body: JSON.stringify([
      { artifactId: id, artifactType: type, frequency, productCategory, purchaseType },
    ]),
  };

  const response = await fetchApi(resourceUrl, params);

  return response.json();
};

export const postOrderMany = async ({ products, isin = false }) => {
  const userId = getUserId();

  const resourceUrl = `/storefront/users/${userId}/orders${
    isin ? '/isin_upload?source=ISINUPLOAD' : ''
  }`;

  const params = {
    method: 'POST',
    body: JSON.stringify(products),
  };

  const response = await fetchApi(resourceUrl, params);

  return isin ? response : response.json();
};
